import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import { examAPI } from '../../services/api';

const StudentExams = () => {
  const { user } = useAuth();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadExams = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await examAPI.getAll({ standard: user?.standard });
        setExams(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load exams');
      } finally {
        setLoading(false);
      }
    };

    loadExams();
  }, [user?.standard]);

  return (
    <Box>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        Exams
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

      <Paper sx={{ p: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Exam</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {exams.length > 0 ? exams.map((exam) => (
                  <TableRow key={exam.id} hover>
                    <TableCell>{exam.exam_name}</TableCell>
                    <TableCell>{exam.exam_type}</TableCell>
                    <TableCell>{exam.start_date ? new Date(exam.start_date).toLocaleDateString() : '-'}</TableCell>
                    <TableCell>{exam.end_date ? new Date(exam.end_date).toLocaleDateString() : '-'}</TableCell>
                    <TableCell>{Number(exam.is_published) === 1 ? 'Published' : 'Draft'}</TableCell>
                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">No exams found.</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Box>
  );
};

export default StudentExams;
